// extracted by css-extract-rspack-plugin
export default {"wrapper":"_86f0a06d","textWrapper":"_8b4032d0","header":"_745b7821","subHeader":"_3b3fcbc5","imageWrapper":"_a9c538ca","image":"_23349d9","imageCaption":"_78af02b7"};